/* eslint-disable prefer-rest-params */
import $ from 'jquery';
// support old jquery feature
// this feature was used inside jquery.validate.unobtrusive
$.fn.live = function liveFallback(types, data, fn) {
	$(this.context).on(types, this.selector, data, fn);
	return this;
};

// this feature was used inside jquery.validate-1.11.1
const oldSelf = $.fn.andSelf || $.fn.addBack;
$.fn.andSelf = function andSelfFallback() {
	// migrateWarn("jQuery.fn.andSelf() replaced by jQuery.fn.addBack()");
	return oldSelf.apply(this, arguments);
};

// this feature was used inside jquery validate
const oldParseJSON = $.parseJSON;
$.parseJSON = function parseJSONFallback(json) {
	if (!json && json !== null) {
		// migrateWarn("jQuery.parseJSON requires a valid JSON string");
		return null;
	}
	return oldParseJSON.apply(this, arguments);
};



// WEBPACK FOOTER //
// ./Scripts/libs/common/support-old-jquery.js